<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تیکت ها
                  <!-- <i class="mdi mdi-information-outline"></i>  -->
                </div>
                <span>
                  <router-link :to="{name:'AddTicket'}" class="ar-btn size-md primary round">
                    <i class="mdi mdi-plus"></i>
                    <span>افزودن تیکت</span>
                  </router-link>
                </span>
              </div>
              <div class="ar-card-body">
                
                <div class="row">
                  <div class="col-xl-8 col-md-6 col-sm-12"></div>
                  <div class="col-xl-4 col-md-6 col-sm-12">

                    <div class="ar-form-group">
                      <select class="ar-form-control" v-model="filter">
                        <option value="0">در انتظار پاسخ</option>
                        <option value="1">پاسخ داده شده</option>
                        <option value="2">بسته شده</option>
                      </select>
                    </div>

                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>عنوان</th>
                        <th>اهمیت</th>
                        <th>بخش</th>
                        <th>تاریخ ثبت</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in filtered" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>{{item.subject}}</td>
                        <td>
                          <span v-if="item.priority == 'زیاد'" class="text-danger">{{item.priority}}</span>
                          <span v-if="item.priority == 'متوسط'" class="text-warning">{{item.priority}}</span>
                          <span v-if="item.priority == 'کم'" class="text-secondary">{{item.priority}}</span>
                        </td>
                        <td>{{item.section}}</td>
                        <td>{{item.shamsi_created_at}}</td>
                        <td>
                          <router-link :to="{name:'Ticket' , params:{id:item.id}}">
                            <i class="mdi mdi-information-outline"></i>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-if="!Object.keys(filtered).length" class="py-4 text-center text-primary-dark">
                  تیکت 
                  <template v-if="filter == 0">در انتظار پاسخی</template>
                  <template v-if="filter == 1">پاسخ داده شده ای</template>
                  <template v-if="filter == 2">بسته شده ای</template>
                  وجود ندارد.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import {TheMask} from 'vue-the-mask'
export default {
  name: 'Tickets',
  components:{
    Sidebar,
    Header,
    HelperNav,
    TheMask
  },
  data : () => ({
    clicked:'mon',
    hovered:'',
    loading:false,
    filter:0,
    items:{},
  }),
  computed:{
    filtered() {
      if(this.items.length > 1)
      {
        
        return this.items.filter( item => {
          return item.status == this.filter
        })

      }
    }
  },
  methods:{
    tickets(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.get(`tickets`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.items = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
    this.tickets()
  }
}
</script>
<style >
.custom{
  font-size: 18px !important;
  padding: 12px 32px !important;
}
</style>